<template>
  <div class="shopApp" :style="'height:'+curHeight+'px;background:url('+bg+') no-repeat;background-size:100% 100% !important;'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div class="search">
      <input type="text" v-model="keywork" placeholder="请输入关键词搜索"/>
      <button @click="search">搜索</button>
    </div>
    <div style="height:55px;"></div>
    <ul>
      <li>
        <img src="http://admin.4008005216.com//upload/20210617/8e59c304c40c343643b091857b341982.jpg" />
        <div class="right">
          <h2>大明山菜园店家</h2>
          <p>
            <font>大明山风景名胜区为国家AAAA级风景名胜区，大明山位于临安西部顺溪镇，别名千亩田，山颠平坦，广达千亩，故名。大明山面积约29平方公里。风景区以大明山为主体，共有32峰。</font>
          </p>
        </div>
      </li>
      <li>
        <img src="http://admin.4008005216.com//upload/20210617/8e59c304c40c343643b091857b341982.jpg" />
        <div class="right">
          <h2>北海红树林菜园店家</h2>
          <p>
            <font>红树林是热带、亚热带海岸潮间带特有的胎生木本植物群落，素有"海上森林"之称，幽秘神奇、倚海而生，随潮涨而隐、潮退而现，是国家级重点保护的珍稀植物。北海山口镇的国家级红树林自然保护区位于广西北海市合浦县境内，海岸线长50公里，面积8000公顷，光热充足，港湾深入内陆，封闭好，海水污染程度低，理化性质稳定，滩涂淤泥肥沃，适宜于红树林生长，保护红树林面积为7.2平方公里，共有红海榄树、秋茄、桐花树等12种红树林植物，是广西乃至全国大陆海岸发育良好，连片大，结构较典型，保护较完整的红树林区。</font>
          </p>
        </div>
      </li>
      
    </ul>
  </div>
</template>

<script>
  import $ from 'jquery' //在需要使用的页面中
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        userData:[],
        code:'',
        bg:require('../../assets/images/farm.png'),
      };
    },

    beforeMount() {
      if(localStorage.getItem('userjwt') == null){
        var code = this.codefun('code');
        if(!code){
          var url = encodeURIComponent('http://user.4008005216.com/main/farm');
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
        }
      }else{
        this.userData = JSON.parse(localStorage.getItem('userjwt'));
      }
    },
    mounted() {
      this.beforeMount();
      if(localStorage.getItem('userjwt') == null){
        this.login();
      }
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },

      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          that.userData = res.data;
          localStorage.setItem('userjwt', JSON.stringify(res.data));
        }).catch(err=>{

        });
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      }
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .shopApp{
    max-width:640px;
    margin:0 auto;
    background-size: 100% 100%;
    overflow-y: scroll;
  }

  .shopApp li{
    width:88%;
    display:block;
    background:rgba(255,255,255,.8);
    margin:0 auto;
    border-radius: 10px;
    padding:3%;
    margin-bottom:10px
  }
  .shopApp li:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }

  .shopApp li img{
    float:left;
    width:35%;
    border-radius: 8px;
  }
  .shopApp li .right{
    float:left;
    width:65%
  }
  .shopApp li .right h2{
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    color: #333333;
    font-size:15px;
    padding-left:8px
  }
  .shopApp li .right p{
    padding-left:8px;
    padding-top:14px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }
  .shopApp li .right p font{
    font-size: 15px;
    color: #999999;
  }


  .shopApp .search{
    position:fixed;
    width:100%;
    left:0;
    background:#f7faff;
    height:45px;
    top:0;
    z-index:99
  }
  .shopApp .search input{
    display:block;
    width:90%;
    height:35px;
    margin:0 auto;
    border:none;
    outline:none;
    padding:0 2%;
    font-size:15px;
    color:#333;
    border-radius:6px;
    margin-top:5px;
  }
  .shopApp .search button{
    position:absolute;
    top:5px;
    right:3%;
    z-index:33;
    height:35px;
    border:none;
    border-top-right-radius:6px;
    border-bottom-right-radius:6px;
    background:#00D138;
    font-size:15px;
    color:#fff;
    width:60px;
    outline:none;
  }
</style>